export enum StudioEvent {
    Download = 'Studio Download',
}
